import uniq from 'lodash/uniq';

function hasDuplicated(arr) {
  return arr.length > uniq(arr).length;
}

export default hasDuplicated;
